import React from 'react';
import { useHistory } from 'react-router-dom';

function CurriculumVitaeEnd() {
  const history = useHistory();

  const handleFinish = () => {
    history.push('/curriculumVitae/start');
  };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center">
      <div className="text-center t4t-card p-5 rounded shadow-lg" style={{ maxWidth: '80%' }}>
        <h1 className="mb-4">Thank you for completing your CV information!</h1>
        <p className="text-secondary" style={{ lineHeight: '1.6', fontSize: '1.1rem' }}>
          You have successfully completed all the steps of the wizard. All your information has been securely saved and processed. You can now view and edit your complete
          CV in the main menu of the CV module.
        </p>

        <p className="text-secondary" style={{ lineHeight: '1.6', fontSize: '1.1rem' }}>
          Click &quot;Finish&quot; to return to the main menu.
        </p>

        <button className="btn btn-primary px-5 py-2 mx-auto mt-3" onClick={handleFinish}>
          <span>Finish</span>
        </button>
      </div>
    </div>
  );
}

export default CurriculumVitaeEnd;
